import {InjectionToken} from "@angular/core";

export interface SvgAssetIconConfig {
  svgAssets: {[k:string]: string}
}
export const ICON_SVG_ASSET_CONFIG = new InjectionToken<SvgAssetIconConfig>('ICON_SVG_ASSET_CONFIG');
